/**
 * Created by mh on 2017/5/28.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';
import TimelineEventModel from './model/TimelineEventModel';
import AssetVisualPreview from '../assets/AssetVisualPreview';
import AssetStore from '../assets/model/AssetStore';

const TypeToColorClass = (type) => {
    switch (type) {
    case 'audio':
        return 'badge-primary';
    case 'video':
        return 'badge-info';
    default:
        return 'badge-secondary';
    }
};

const MsToTime = (duration) => {
    const milliseconds = parseInt((duration % 1000) / 100, 10);
    let seconds = parseInt((duration / 1000) % 60, 10);
    let minutes = parseInt((duration / (1000 * 60)) % 60, 10);
    let hours = parseInt((duration / (1000 * 60 * 60)) % 24, 10);

    hours = (hours < 10) ? `0${hours}` : hours;
    minutes = (minutes < 10) ? `0${minutes}` : minutes;
    seconds = (seconds < 10) ? `0${seconds}` : seconds;

    return `${hours}:${minutes}:${seconds}.${milliseconds}`;
};

const TypeBadge = type => <span className={`badge ${TypeToColorClass(type)}`}>{type}</span>;

@inject('auth') @observer
export default class TimelineEventTableRow extends React.Component {
    componentDidMount = () => {
        this.store = AssetStore.fromJS(this.props.auth, []);
        this.store.fetchAsset(this.props.event.mockAsset.asset_id);
    };
    @observable store;

    render() {
        const { event } = this.props;
        const startTime = new Date(event.startTime).toLocaleTimeString();

        return (
            <tr>
                <td className="align-middle">
                    <Link className="" to={`/assets/details/${event.mockAsset.asset_id}/`}>
                        <AssetVisualPreview
                            asset={this.store && this.store.asset && this.store.fetched ? this.store.asset : null}
                            previewStill
                            width={50} />
                    </Link>
                </td>
                <td className="align-middle">{TypeBadge(event.type)}</td>
                <td className="align-middle" style={{ whiteSpace: 'nowrap' }}>{startTime}</td>
                <td className="align-middle">{MsToTime(event.durationMs)}</td>
                <td className="align-middle">{event.mockAsset.name}</td>
                <td className="align-middle">
                    <Link className="btn btn-sm btn-secondary" to={`${event.id}/`}>+</Link>
                </td>
            </tr>);
    }
}
TimelineEventTableRow.wrappedComponent.propTypes = {
    auth: PropTypes.object.isRequired,
    event: PropTypes.instanceOf(TimelineEventModel).isRequired,
};
